import './JobApplicationCloseWarning.css';

function JobApplicationCloseWarning() {
	return (
		<span
			className="job-application-close-warning"
			title="Application needs to request to close."
		>
			<i className="bi bi-info-lg" />
		</span>
	);
}

export default JobApplicationCloseWarning;
